import { useAppTab } from "@1js/acui-tablist";
import type { TabProps, TabState } from "./Tab.types";
import { useTabState } from "./useTabState";

export const useTab = (
  props: TabProps,
  ref: React.ForwardedRef<HTMLButtonElement>
): TabState => {
  const tabState = useAppTab(props, ref);

  return useTabState(props, tabState);
};
